import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36de7b0a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=36de7b0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de7b0a",
  null
  
)

export default component.exports